/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { Props as SelectProps, StylesConfig } from 'react-select'
import ReactSelect from 'react-select'
import { InfosInputs } from 'styles/global'
import { SelectArea } from './style'
import { Tooltip } from '@mui/material'

interface CustomSelectProps extends SelectProps {
  accessorLabel?: string
  accessorValue?: string
  options: any[]
  onChange?: (e: any) => void
  value?: any
  invalid?: boolean
  disabled?: boolean
  width?: number
  height?: number
  borderRadius?: number
  errorMessage?: string
  infoMessage?: string
}

const CustomSelect = ({
  placeholder = 'Selecione',
  accessorValue = 'id',
  accessorLabel = 'label',
  options,
  value,
  onChange,
  invalid,
  disabled,
  width,
  errorMessage,
  infoMessage,
  height,
  borderRadius,
  ...props
}: CustomSelectProps) => {
  const [optionsSelect, setOptionsSelect] = useState<any[]>()
  const [optionSelected, setOptionSelected] = useState<any>()

  useEffect(() => {
    setOptionsSelect([])
    options?.map((option: any) =>
      setOptionsSelect((state: any) => [
        ...state,
        { value: option[accessorValue], label: option[accessorLabel] }
      ])
    )
  }, [options, accessorValue, accessorLabel])

  useEffect(() => {
    if (!props.isMulti) {
      if ((value !== false && value !== true && !value) || value === '0') {
        setOptionSelected(null)
      } else {
        const optionSelected = optionsSelect?.find(
          (option: any) => option.value === value
        )
        if (optionSelected) {
          setOptionSelected(optionSelected)
        } else {
          setOptionSelected(null)
        }
      }
    } else {
      if (value) {
        const optionsSelecteds: any[] = []
        value?.map((e: any) => {
          const index = optionsSelect?.findIndex(
            (option: any) => option.value === e
          )
          if ((index || index === 0) && index !== -1 && optionsSelect) {
            optionsSelecteds.push(optionsSelect[index])
          }
        })
        setOptionSelected(optionsSelecteds)
      }
    }
  }, [optionsSelect, props.isMulti, value])

  function onSelect(option: any) {
    setOptionSelected(option)
  }

  const customStyles: StylesConfig = {
    control: (provided, state) => {
      return {
        ...provided,
        borderRadius: borderRadius || '15px',
        width: width || provided.width,
        height: height || provided.height,
        borderColor: invalid
          ? '#dc3545'
          : state.isFocused
          ? '#2684FF'
          : '#ced4da',
        boxShadow: state.isFocused
          ? invalid
            ? '0 0 0 0.25rem rgb(220 53 69 / 25%)'
            : '0 0 0 0.25rem rgb(13 110 253 / 25%)'
          : '',
        ':hover': {
          borderColor: invalid
            ? '#dc3545'
            : state.isFocused
            ? '#2684FF'
            : '#ced4da'
        }
      }
    }
  }

  return (
    <SelectArea>
      <ReactSelect
        isClearable
        styles={customStyles}
        options={optionsSelect}
        placeholder={placeholder}
        value={optionSelected}
        onChange={(e: any) => {
          if (onChange) {
            if (!props.isMulti) {
              e?.value || e?.value === false
                ? onChange(e?.value)
                : onChange(null)
            } else {
              const values: any[] = []
              e.map((value: any) => {
                values.push(value.value)
              })
              onChange(values)
            }
          }
          onSelect(e)
        }}
        noOptionsMessage={() => {
          return <span>Sem opções</span>
        }}
        isDisabled={disabled}
        {...props}
      />
      {infoMessage && <InfosInputs>{infoMessage}</InfosInputs>}
      {invalid && errorMessage && (
        <Tooltip title={errorMessage} placement="bottom-start">
          <span className="error-message">{errorMessage}</span>
        </Tooltip>
      )}
    </SelectArea>
  )
}

export default CustomSelect
